import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "pt-8 text-2xl font-bold text-dark" }, "Asset is shared to", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_details_view = _resolveComponent("custom-details-view")!
  const _component_custom_table = _resolveComponent("custom-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_custom_details_view, {
        isDevice: true,
        "no-qr-icon": true,
        "table-data": _ctx.deviceAssignment,
        "table-headers": _ctx.deviceLabels,
        title: "Asset",
        onCopyToClipboard: _ctx.copyToClipBoard
      }, null, 8, ["table-data", "table-headers", "onCopyToClipboard"]),
      _hoisted_3,
      _createVNode(_component_custom_table, {
        "is-action-list-not-displayed": true,
        "table-data": _ctx.usersSharedToDevice,
        "table-headers": _ctx.tableHeaders
      }, null, 8, ["table-data", "table-headers"])
    ])
  ]))
}